import React, { Component, Children, cloneElement } from 'react'
import { RollbackOutlined, SearchOutlined } from '@ant-design/icons'
import { Form, Icon as LegacyIcon } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Button } from 'hljd'
import SearchBarItem from './SearchBarItem'
import { SEARCHBAR_ITEM_DISPLAY_NAME, isSearchBarItem } from './util'

const FormItem = Form.Item

const Item = ({ children }) => <span>{children}</span>
Item.displayName = SEARCHBAR_ITEM_DISPLAY_NAME

@Form.create({
  onValuesChange: (props, values) => {
    const { noNeed, onChange, store } = props
    if (onChange) {
      onChange(values, noNeed)
    } else {
      store && store.$setParams && store.$setParams(values, noNeed)
    }
  }
})
export default class SearchBar extends Component {
  static defaultProps = {
    style: {},
    showReset: true,
    showSearch: true,
    searchText: '搜索',
    resetText: '重置',
    onAfterReset: null,
    onSearch: null,
    expand: null,
    expandOp: null,
    auto: true,
    noNeed: [],
    overflowCount: 15
  }
  count = 0
  state = {
    _expand: false
  }
  reset = () => {
    const { onAfterReset, form, store, noNeed } = this.props
    form.resetFields()
    if (onAfterReset) {
      onAfterReset(null, noNeed)
    } else {
      store && store.$setParams && store.$setParams(null, noNeed)
    }
  }
  search = () => {
    const { onSearch, store } = this.props
    if (onSearch) {
      onSearch()
    } else {
      store && store.$search && store.$search()
    }
  }

  UNSAFE_componentWillMount() {
    const { form, onInited } = this.props
    onInited && onInited(form)
  }

  componentWillUnmount() {
    const store = this.props.store
    store && store.$resetParams && store.$resetParams()
  }

  handleProps = item => {
    let _item = item
    if (item.props) {
      let cloneObj = {}
      const itemProps = item.props
      const { form, store } = this.props
      Object.keys(itemProps).forEach(prop => {
        if (itemProps[prop] && isSearchBarItem(itemProps[prop])) {
          cloneObj[prop] = (
            <SearchBarItem
              {...itemProps[prop].props}
              isForm={false}
              form={form}
              store={store}
            />
          )
        }
      })
      _item = cloneElement(item, cloneObj)
    }
    return _item
  }
  handleChild = (children, isExpand) => {
    const { overflowCount, form, store } = this.props
    return Children.map(children, item => {
      if (!item) return null
      if (isSearchBarItem(item)) {
        let hidden = item.props.hidden
        if (!hidden) {
          this.count++
        }
        if (!isExpand && this.count > overflowCount) {
          hidden = true
        }
        return (
          <SearchBarItem
            {...item.props}
            hidden={hidden}
            form={form}
            store={store}
          >
            {this.handleProps(item.props.children)}
          </SearchBarItem>
        )
      } else {
        return <Item>{this.handleProps(item)}</Item>
      }
    })
  }
  handleExpand = () => {
    const { expand, onExpand } = this.props
    if (onExpand) {
      onExpand(!expand)
    } else {
      this.setState({
        _expand: !this.state._expand
      })
    }
  }

  render() {
    const {
      showReset,
      showSearch,
      searchText,
      resetText,
      before,
      after,
      overflowCount,
      expand,
      style,
      children,
      expandOp
    } = this.props
    const { _expand } = this.state
    const isExpand = expand === undefined || expand === null ? _expand : expand
    this.count = 0

    const _child = this.handleChild(children, isExpand)
    return (
      <Form layout="inline" style={style}>
        {before}
        {_child}
        {showSearch && (
          <FormItem>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={this.search}
            >
              {searchText}
            </Button>
          </FormItem>
        )}
        {showReset && (
          <FormItem>
            <Button
              type="dashed"
              icon={<RollbackOutlined />}
              onClick={this.reset}
            >
              {resetText}
            </Button>
          </FormItem>
        )}
        {after}
        {this.count > overflowCount &&
          (expandOp || (
            <FormItem>
              <Button
                type="dashed"
                onClick={this.handleExpand}
                icon={<LegacyIcon type={isExpand ? 'up' : 'down'} />}
              >
                {isExpand ? '收起' : '展开'}
              </Button>
            </FormItem>
          ))}
      </Form>
    )
  }
}
SearchBar.Item = Item
